import { useState, type KeyboardEvent } from 'react'
import { Box, Input, IconButton, Text } from '~/design_system'
import { useMsg } from '~/common/localizationUtils'
import { ArrowUp } from '~/assistant/icons'
import { useChatContext } from '../ChatContext'

export const ThreadFooter = () => {
  const [inputValue, setInputValue] = useState('')
  const msg = useMsg()
  const thread = useChatContext()

  const handleSubmit = async () => {
    const prompt = inputValue.trim()
    if (!prompt) return
    if (await thread.submitMessage(prompt)) setInputValue('')
  }

  const handleKeyDown = (e: KeyboardEvent) => {
    if (e.key === 'Enter' && !e.shiftKey) {
      e.preventDefault()
      handleSubmit()
    }
  }

  return (
    <Box px={5} pb={5} pt={0}>
      <Box position="relative">
        <Input
          value={inputValue}
          onChange={e => setInputValue(e.target.value)}
          onKeyDown={handleKeyDown}
          placeholder={msg('assistant.ai.input.placeholder')}
          disabled={thread.isThreadError}
          bg="gray.100"
          border="0"
          borderRadius="full"
          h="56px"
          pl={6}
          pr={14}
          fontSize="15px"
          _placeholder={{ color: 'gray.500' }}
          _focus={{ bg: 'gray.100', boxShadow: '0 0 0 2px var(--chakra-colors-blue-100)' }}
        />
        <IconButton
          onClick={handleSubmit}
          aria-label={msg('assistant.ai.button.send')}
          icon={<ArrowUp boxSize="16px" />}
          isLoading={thread.isBusy}
          isDisabled={!inputValue.trim() || thread.isThreadError}
          position="absolute"
          right={2}
          top="50%"
          transform="translateY(-50%)"
          h="36px"
          w="36px"
          minW="36px"
          borderRadius="full"
          bg="hsl(210, 90%, 88%)"
          color="hsl(210, 90%, 30%)"
          _hover={{ bg: 'hsl(210, 90%, 82%)' }}
          zIndex={1}
        />
      </Box>
      <Text fontSize="xs" color="gray.500" textAlign="center" mt={2.5}>
        {msg('assistant.ai.disclaimer')}
      </Text>
    </Box>
  )
}
